import { render } from "./events-page.vue?vue&type=template&id=7ebbf915"
import script from "./events-page.vue?vue&type=script&lang=js"
export * from "./events-page.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__